<template>
  <div>
    <div class="flex-center">
      <div class="title">我的印章</div>
      <!-- <el-button type="primary" icon="el-icon-s-promotion" class="sign-button mr20 fz15">发起签章</el-button> -->
    </div>
    <div class="seal-list">
      <div class="seal-item flex-dir-center" v-for="(item, index) in sealData" :key="index">
        <img v-if="item.sealStatus == 1" class="seal-label" src="@/assets/user/image-filing-cert.png"
             @click="handleDownProof(item)">
        <img v-if="item.sealStatus == 9" class="seal-revoke" src="@/assets/ic_revoke.png">
        <img v-if="item.sealStatus == 0" class="seal-making" src="@/assets/ic_making.png">
        <img v-if="item.uid !== '0000'" class="seal-ukey" src="@/assets/ic_ukey.png">
        <div class="seal-area">
          <img class="seal-img" :src="item.sealImage" alt/>
        </div>
        <div class="seal-bottom flex-center-between">
          <div class="flex-center fc6 fz14 pointer seal-detail" @click="handleDetail(item)">
            <img class="icon-seal" src="@/assets/user/icon-more.png" alt="">
            详情
          </div>
          <el-dropdown v-if="item.sealStatus == 1" trigger="click" @command="e => handleCommand(e, item)"
                       class="pointer">
            <div class="flex-center fc6">
              <img class="icon-seal" src="@/assets/user/icon-setting.png" alt="">
              管理
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="c"><i class="el-icon-odometer"></i>续期印章</el-dropdown-item>
              <el-dropdown-item command="d"><i class="el-icon-switch-button"></i>注销印章</el-dropdown-item>
              <!--              <el-dropdown-item command="f"><i class="el-icon-setting"></i>用印审批</el-dropdown-item>-->
              <!--              <el-dropdown-item command="e" v-if="item.supportRsa == 0"><i class="el-icon-s-check"></i>RSA认证</el-dropdown-item>-->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="seal-name">{{ item.name }}</div>
      </div>
      <div class="seal-item">
        <div class="apply-item" @click="handleApply">
          <img class="apply-img" src="@/assets/user/image-apply-seal.png" alt/>
          <div class="fz16 mt10">{{ $store.state.account.user.type == 1 ? '申领私章' : '申领公章' }}</div>
        </div>
      </div>
    </div>
    <CheckDetail ref="checkRef" :sealType="sealType"></CheckDetail>

    <r-s-a-detail ref="RSADetail"/>

    <examine-and-approve ref="examineAndApprove"/>
  </div>
</template>

<script>
import CheckDetail from './CheckDetail.vue'
import RSADetail from "@/pages/customerEnterprise/components/RSADetail.vue";
import ExamineAndApprove from "@/pages/userCenter/components/examineAndApprove.vue";

export default {
  props: {
    sealData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {ExamineAndApprove, RSADetail, CheckDetail},
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      sealType: [],
    };
  },
  mounted() {
    this.getSealType()
  },
  methods: {
    handleApply() {
      if (this.$store.state.account.user.type == 1) {
        this.$router.push({
          path: "/register/sealConfirm",
        });
      } else {
        this.$router.push({
          path: "/register/officialConfirm",
        });
      }
    },
    getSealType() {
      this.$http.post(this.$api.user.getSealType).then(res => {
        if (res.data.code == 200) {
          this.sealType = res.data.data
        }
      })
    },
    handleCommand(command, item) {
      switch (command) {
        case "d":
          this.handleLogOff(item)
          break;
        case "c":
          this.handleRenew(item)
          break;
        case "b":
          this.$refs.returnRef.show()
          break;
        case "a":
          this.$refs.changeRef.show()
          break;
        case "e":
          this.$refs.RSADetail.open(item)
          break;
        case "f":
          this.$refs.examineAndApprove.show(item)
          break;
      }

    },
    handleLogOff(item) {
      this.$confirm('此操作将注销该印章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onLogOff(item)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    onLogOff(item) {
      let params = {
        sealCode: item.sealCode
      }
      this.$http.get(this.$api.user.deactivateSeal, params).then(res => {
        if (res.data.code == 200) {
          // item.sealStatus = 9
          this.$emit('getESealInfo')
          this.$message.success(res.data.msg)
        }
      })
    },
    handleRenew(item) {
      this.$confirm('此操作将续期该印章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onRenew(item)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    onRenew(item) {
      let params = {
        sealCode: item.sealCode
      }
      this.$http.get(this.$api.user.renewSeal, params).then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.msg)
        }
      })
    },
    handleDetail(item) {
      this.$refs.checkRef.show(item)
    },
    handleDownProof(item) {
      top.window.location.href = this.baseUrl + this.$api.user.downProof + '?sealCode=' + item.sealCode
    }
  },
};
</script>
<style lang="less" scoped>
.title {
  border-top: 6px solid #407fff;
  width: 106px;
  font-weight: 400;
  font-size: 26px;
  color: #000;
  padding-top: 12px;
}

.seal-list {
  padding-top: 35px;

  .seal-item {
    position: relative;
    // display: block;
    width: 22%;
    height: 254px;
    margin: 0 3% 30px 0;
    float: left;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);

    &:hover {
      scale: 1.05;
      box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
    }

    .seal-label {
      position: absolute;
      right: -5px;
      top: -4px;
      width: auto;
      z-index: 8;
      cursor: pointer;
    }

    .seal-ukey {
      position: absolute;
      right: 0;
      bottom: 43px;
      width: 32px;
      z-index: 8;
    }

    .seal-revoke {
      position: absolute;
      right: 0;
      top: 0;
      width: auto;
      z-index: 8;
    }

    .seal-making {
      position: absolute;
      right: 0;
      top: 0;
      width: 48px;
      z-index: 8;
    }

    .apply-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 100%;
      border: 1px dashed #ebebeb;
      background: #f7faff;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        scale: 1.05;
        box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
      }
    }

    .apply-img {
      width: 51px;
    }

    .seal-area {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      border-bottom: 1px solid #ebebeb;
    }

    .seal-name {
      position: absolute;
      bottom: -25px;
    }

    .seal-bottom {
      padding: 10px 13px;
      width: 100%;

      .seal-detail:hover {
        color: red;
      }
    }

    .seal-img {
      width: 150px;
    }

    .icon-seal {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }
}

::v-deep .el-dropdown-menu__item {
  padding: 0 40px !important;
}
</style>
